import { I18nComponente } from "@/types/gerais"

export const OArvoreDeSelecoesi18n: I18nComponente = {
  "pt-BR": {
    nenhumResultadoEncontrado: "Nenhum resultado encontrado"
  },
  "es-CO": {
    nenhumResultadoEncontrado: "Ningún resultado encontrado"
  }
}
